// utils/numberUtils.js
class NumberUtils {
  static removeTrailingZeros(num) {
    const numStr = num.toString();
    const numWithoutZeros = numStr.includes(".")
      ? numStr.replace(/\.?0+$/, "")
      : numStr;
    return numWithoutZeros;
  }
}

export default NumberUtils;
